// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar-module--avatar--3hTp9"};